import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { PalabraClave } from '../../_models/palabra-clave';
import { PalabraClaveActividadEconomica } from '../../_models/palabra-clave-actividad-economica';
import { PalabraClaveService } from '../../_services/palabra-clave.service';
import { PalabraClaveActividadEconomicaService } from '../../_services/palabra-clave-actividad-economica.service';
import { forkJoin } from 'rxjs';
import { NavService } from '../../_services/_nav.service';

@Component( {
  selector: 'app-palabra-clave-detalle',
  templateUrl: 'palabra-clave-detalle.component.html'
} )

export class PalabraClaveDetalleComponent implements OnInit {

  palClave: PalabraClave;
  lisPalabraClaveActividades: PalabraClaveActividadEconomica[] = [];
  carInformacionInicial = true;
  columnas: any[];

  constructor( private palClaveServicio: PalabraClaveService,
               private palClaveActividadEconomicaServicio: PalabraClaveActividadEconomicaService,
               private navServicio: NavService,
               private route: ActivatedRoute, private location: Location ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'nombreActividadEconomica', header: this.navServicio.buscarMensaje( 'PALABRACLAVE.LBL_ACTIVIDADECONOMICA' ), sort: true }
    ];

    this.route.params.subscribe( ( params: Params ) => {
      forkJoin( this.palClaveServicio.obtenerPorId( params[ 'id' ] ), this.palClaveActividadEconomicaServicio.listadoPorPalabraClave( params[ 'id' ] ) ).subscribe( ( [ palClave, lisPalabraClave ] ) => {
        this.palClave = palClave;
        this.lisPalabraClaveActividades = lisPalabraClave.filter(x => x.indicadorHabilitado);
        this.carInformacionInicial = false;
      } );
    } );
  }

  regresar() {
    this.location.back();
  }
}
